import React from 'react'

import type { GridBlock as BlockProps } from '@/payload-types'
import { RenderBlocks } from '@/blocks/RenderBlocks'
import { cn } from '@/utilities/cn'

export const GridBlock: React.FC<BlockProps> = async ({
  layout,
  center,
  narrow,
  layoutType,
  layoutGaps,
}) => {
  const gridClassName = cn(
    'grid',
    layoutType === 'columns3' && 'grid-cols-1 gap-4 lg:grid-cols-3',
    layoutGaps === 'small' && 'gap-4',
    layoutGaps === 'medium' && 'gap-8',
    layoutGaps === 'large' && 'gap-16',
  )
  const className = cn('container', center && 'mx-auto', narrow && 'max-w-4xl', gridClassName)
  return (
    <div className={className}>
      <RenderBlocks blocks={layout ?? []} />
    </div>
  )
}
